export default __webpack_public_path__ + "static/media/timer.e32f2ee4.png";